import { Divider, Menu, MenuItem, MenuItemLink, MenuProps } from '@freighthub/silhouette-core'
import { FC, MouseEvent, useState } from 'react'
import { useI18n } from 'utils/localisation'

import { BookingTemplatesPopup } from './BookingTemplatesPopup'
import { RecentQuotesPopup } from './RecentQuotesPopup'

enum PopupId {
  RecentQuotes,
  BookingTemplates,
}

export const testIds = {
  menu: 'new-quote-menu-root',
  link: 'new-quote-menu-link',
  recentQuotesMenuItem: 'new-quote-menu-recent-quotes',
  bookingTemplatesMenuItem: 'new-quote-menu-booking-templates',
  recentQuotesPopup: 'recent-quotes-popup',
  bookingTemplatesPopup: 'booking-templates-popup',
}

export interface NewQuoteMenuProps extends MenuProps {
  onClose: () => void
}

export const NewQuoteMenu: FC<NewQuoteMenuProps> = ({ open, anchorEl, onClose, ...props }) => {
  const { translate } = useI18n()
  const [popupAnchorEl, setPopupAnchorEl] = useState(null)
  // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  const [activePopupId, setActivePopupId] = useState<PopupId>(null)

  const handleClickCascadedItem = (event: MouseEvent<HTMLLIElement>) => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'EventTarget & HTMLLIElement' is ... Remove this comment to see the full error message
    setPopupAnchorEl(event.currentTarget)
    setActivePopupId(event.currentTarget.value)
  }

  const handleClose = () => {
    setPopupAnchorEl(null)
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    setActivePopupId(null)
    onClose()
  }

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      width="auto"
      data-testid={testIds.menu}
      {...props}
    >
      <MenuItemLink
        to="/quote-request"
        onClick={onClose}
        data-testid={testIds.link}
        data-userlane-id="new-quote-menu-item-main"
      >
        {translate('sidebar-new_quote')}
      </MenuItemLink>
      <Divider />
      <MenuItem
        value={PopupId.RecentQuotes}
        onClick={handleClickCascadedItem}
        data-testid={testIds.recentQuotesMenuItem}
        data-userlane-id="new-quote-menu-item-recent-quotes"
        cascaded
      >
        {translate('sidebar-new_quote-recent_quotes')}
      </MenuItem>
      <MenuItem
        value={PopupId.BookingTemplates}
        onClick={handleClickCascadedItem}
        data-testid={testIds.bookingTemplatesMenuItem}
        data-userlane-id="new-quote-menu-item-booking-templates"
        cascaded
      >
        {translate('sidebar-new_quote-booking_templates')}
      </MenuItem>

      {/* Popups */}
      <RecentQuotesPopup
        open={Boolean(popupAnchorEl) && activePopupId === PopupId.RecentQuotes}
        anchorEl={popupAnchorEl}
        onClose={handleClose}
        data-testid={testIds.recentQuotesPopup}
      />
      <BookingTemplatesPopup
        open={Boolean(popupAnchorEl) && activePopupId === PopupId.BookingTemplates}
        anchorEl={popupAnchorEl}
        onClose={handleClose}
        data-testid={testIds.bookingTemplatesPopup}
      />
    </Menu>
  )
}
